import React from 'react'

export default ({ node }) => <div>{node.extras.audio?.name || node.extras.message}</div>



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaGatherInput/GatherInputDisplay.jsx